(function detailsGridInitLambda(global) {

  $(function () {

    var Initiializer = WebAccess.components.wrappers.details.DetailsInitiializer;
    var detailsInitiializer = new Initiializer('div.Reference_Detail', global.DetailsDataProvider, {}, WA.components.dataViews.gridPlugins.DetailsContextMenu, WA.CR);
    detailsInitiializer.bind(Initiializer.EVENT.COMPLETE, function (initiializer) {
      global.details = initiializer.gridInstances;
      initiializer.waitForData().done(function () {
        WA._DetailsGridInit.resolve();
      });
    });
  });

  $.when(WA.FormControlsInit, WA.FormInit, WA.DetailsInit).then(function () {
    if (!WA.CR.form.isExist()) return;

    // Логика работы ведущих/ведомых в дательных разделах.
    WA.CR.bindLeaderDrivenLogic();

    //Удаляем пустые строки перед сохранением
    WA.CR.form.bind("prepareSave", function removeEmptyRows() {
      for (var tableName in WA.CR.form.controls.tables) {
        var table = WA.CR.form.controls.tables[tableName];
        var rows = table.rows.toArray();
        var lastRow = rows[rows.length - 1];

        if (rows.length && lastRow && !lastRow.hasFilledRequisites() && !lastRow._locked) {
          table.deleteRow(lastRow.getRowId(), true);
        }
      }
    });

  });


})(window.Core.grid);